import { InfoCircleOutlined } from '@ant-design/icons/lib/icons';
import { Divider, Modal, Select, Typography } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import selectors from '../../store/selectors';

export const OFFERING_TYPE_WITH_TIME = {
  value: 'with_time',
  label: 'W wybranym terminie',
};

const formatInboxDictionary = inboxDictionary => {
  return inboxDictionary.map(item => ({
    value: item.id,
    label: item.title,
    description: item.description,
  }));
};

const VariousMassOfferingSelector = ({
  fieldName,
  onChange,
  disabled,
  fieldValue,
  inboxDictionary,
}) => {
  const [isMassesInfoModalOpen, setMassesInfoModalOpen] = useState(false);
  const showMassesInfoModal = () => {
    setMassesInfoModalOpen(true);
  };
  const hideMassesInfoModal = () => {
    setMassesInfoModalOpen(false);
  };

  const massOfferingFeatureFlag = useSelector(selectors.selectMassOfferingFeatureFlag);
  const accountMassOfferingTypes = formatInboxDictionary(inboxDictionary);

  const selectedOptionMetadata = accountMassOfferingTypes?.find(
    offeringType => offeringType.value === fieldValue,
  );

  return (
    <>
      <Typography.Title level={4}>
        Rodzaj Mszy Świętej&nbsp;&nbsp;&nbsp;
        <InfoCircleOutlined onClick={showMassesInfoModal} />
      </Typography.Title>

      <Select
        disabled={disabled}
        name={fieldName}
        variant="outlined"
        onChange={newType => {
          if (onChange) {
            onChange(newType);
          }
        }}
        value={fieldValue}
        style={{ width: '300px' }}
      >
        {massOfferingFeatureFlag && (
          <Select.Option value={OFFERING_TYPE_WITH_TIME.value}>
            {OFFERING_TYPE_WITH_TIME.label}
          </Select.Option>
        )}

        {accountMassOfferingTypes.map(object => {
          return (
            <Select.Option key={object.value} value={object.value}>
              {object.label}
            </Select.Option>
          );
        })}
      </Select>

      {selectedOptionMetadata && selectedOptionMetadata.value !== OFFERING_TYPE_WITH_TIME.value && (
        <>
          <Divider />
          <div>{selectedOptionMetadata.description}</div>
        </>
      )}

      {accountMassOfferingTypes && (
        <Modal
          title="Jaki rodzaj Mszy Świętej wybrać"
          open={isMassesInfoModalOpen}
          onOk={hideMassesInfoModal}
          onCancel={hideMassesInfoModal}
          okText="Zamknij"
          footer={<></>}
        >
          <>
            {massOfferingFeatureFlag && (
              <React.Fragment key={OFFERING_TYPE_WITH_TIME.value}>
                <b>{OFFERING_TYPE_WITH_TIME.label}</b> - Msza Św. w podanej intencji, będzie
                odprawiona w wybranym terminie
                <br />
              </React.Fragment>
            )}
            {accountMassOfferingTypes.map(offeringType => {
              return (
                <React.Fragment key={offeringType.value}>
                  <b>{offeringType.label}</b> - {offeringType.description}
                  <br />
                </React.Fragment>
              );
            })}
          </>
        </Modal>
      )}
    </>
  );
};

VariousMassOfferingSelector.propTypes = {
  disabled: PropTypes.bool,
  fieldName: PropTypes.string.isRequired,
  fieldValue: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  inboxDictionary: PropTypes.array,
};

export default VariousMassOfferingSelector;
